import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, ScrollView, Dimensions } from 'react-native';
import { tenantActions } from '../../redux/tenant.actions';
import { showSuccesToast } from '../helpers';
import { useDispatch } from 'react-redux';
import moment from 'moment';

const TenantStatusTable = ({ tenants = [], flowId = '' }) => {
  const dispatch = useDispatch();

  return (
    <View style={styles.card}>
      <Text style={styles.title}>Tenants Status</Text>

      <ScrollView horizontal showsHorizontalScrollIndicator={true} contentContainerStyle={{ minWidth: '100%' }}>
        <View style={styles.table}>
          {/* Header Row */}
          <View style={[styles.row, styles.headerRow]}>
            <View style={styles.cell}>
              <Text style={styles.headerText}>Tenant</Text>
            </View>
            <View style={styles.cell}>
              <Text style={styles.headerText}>Status</Text>
            </View>
            <View style={styles.cell}>
              <Text style={styles.headerText}>Sent On</Text>
            </View>
            <View style={styles.cell}>
              <Text style={styles.headerText}>Confirmed On</Text>
            </View>
            <View style={styles.cell}>
              <Text style={styles.headerText}>Nudge</Text>
            </View>
          </View>

          {/* Data Rows */}
          {tenants.map((tenant, index) => (
            <View key={index} style={styles.row}>
              <View style={styles.cell}>
                <Text numberOfLines={1} style={styles.text}>
                  {tenant?.app_user?.user?.first_name} {tenant?.app_user?.user?.last_name}
                </Text>
              </View>

              <View style={styles.cell}>
                <View
                  style={[
                    styles.statusContainer,
                    { borderColor: tenant.tenant_detail_confirmed ? 'green' : 'red' },
                  ]}
                >
                  <Text
                    style={{
                      color: tenant.tenant_detail_confirmed ? 'green' : 'red',
                      fontSize: 14,
                    }}
                  >
                    {tenant.tenant_detail_confirmed ? 'Confirmed' : 'Not Confirmed'}
                  </Text>
                </View>
              </View>

              <View style={styles.cell}>
                <Text style={styles.text}>
                  {tenant.tenant_detail_send_at
                    ? moment(tenant.tenant_detail_send_at).format('DD/MM/YYYY')
                    : '-'}
                </Text>
              </View>

              <View style={styles.cell}>
                <Text style={styles.text}>
                  {tenant.tenant_detail_confirmed_at
                    ? moment(tenant.tenant_detail_confirmed_at).format('DD/MM/YYYY')
                    : '-'}
                </Text>
              </View>

              <View style={styles.cell}>
                <TouchableOpacity
                  onPress={() => {
                    dispatch(
                      tenantActions.rtrReminder(
                        { app_user_id: tenant?.app_user_id },
                        flowId,
                        () => {
                          showSuccesToast('Reminder sent successfully!');
                        },
                        '/openflow/tenant_details/reminder?'
                      )
                    );
                  }}
                  style={styles.nudgeButton}
                >
                  <Text style={styles.nudgeText}>NUDGE</Text>
                </TouchableOpacity>
              </View>
            </View>
          ))}
        </View>
      </ScrollView>
    </View>
  );
};

const screenWidth = Dimensions.get('window').width;

const styles = StyleSheet.create({
  card: {
    padding: 16,
    backgroundColor: 'white',
    borderRadius: 12,
    elevation: 2,
    marginTop: 30,
    marginHorizontal: 10,
  },
  title: {
    fontSize: 16,
    color: '#3f51b5',
    fontWeight: '600',
    marginBottom: 12,
  },
  table: {
    minWidth: 980, // Ensures horizontal scroll works on smaller screens
    width: '100%',
  },

  row: {
    flexDirection: 'row',
    borderBottomWidth: 0.5,
    borderBottomColor: '#ddd',
    paddingVertical: 12,
    alignItems: 'center',
  },
  headerRow: {
    backgroundColor: '#f5f5f5',
  },
  cell: {
    flex: 1,
    paddingHorizontal: 8,
    minWidth: 100, // Ensures each cell has enough width
  },
  headerText: {
    fontWeight: '600',
    fontSize: 14,
  },
  text: {
    fontSize: 14,
    flexShrink: 1,
  },
  statusContainer: {
    borderWidth: 1,
    borderRadius: 12,
    paddingVertical: 4,
    paddingHorizontal: 10,
    alignSelf: 'flex-start',
  },
  nudgeButton: {
    backgroundColor: '#9b5de5',
    paddingHorizontal: 16,
    paddingVertical: 6,
    borderRadius: 8,
    alignSelf: 'flex-start',
  },
  nudgeText: {
    color: 'white',
    fontWeight: 'bold',
  },
});

export default TenantStatusTable;
